module.exports = __webpack_public_path__ + "static/media/background1.e18ce587.png";